import script from "./PrinterOperators.vue?vue&type=script&setup=true&lang=js"
export * from "./PrinterOperators.vue?vue&type=script&setup=true&lang=js"

import "./PrinterOperators.vue?vue&type=style&index=0&id=21d29c81&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d29c81"]])

export default __exports__